




import React, { useContext, useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ChevronRight } from 'lucide-react'; // or react-icons
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getOralCareData } from './OralCareapi';
import CarouselSlider from '../../Shared/CarouselSlider/CarouselSlider';
import IntroSection from '../../Shared/IntroSection/IntroSection';
import SecondSection from '../../Shared/SecondSection/SecondSection';
import CurebaySolutions from '../../Shared/CurebaySolutions/CurebaySolutions';
import ThirdSection from '../../Shared/ThirdSection/ThirdSection';
import CheckHealthSteps from '../../Shared/CheckHealthSteps/CheckHealthSteps'
import ConcernsSection from '../../Shared/ConcernsSection/ConcernsSection';
import { Slider } from "antd";
import DentalUpload from '../Quantum/DentalUpload';

import { Dialog } from 'primereact/dialog';

// import FourthSection from './FourthSection';
// import FifthSection from './FifthSection';
// import LungTestDialog from './LungTestDialog';  

import LoginToast from '../../MainLayout/ToastifyLogin';
// import SeventhSection from '../SkinCare/SeventhSection';
import { LoginContext } from '../../MainLayout/MainLayout';
import { usePatientData } from "../../hooks/usePatientData";
import { FeedbackModal, useServicePageFeedback } from '../Home/FeedbackSystem';






const OralCare = () => {
    const { openLogin } = useContext(LoginContext);
  // const storedData1 = JSON.parse(sessionStorage.getItem("patientData"));
  const storedData1 = JSON.parse(localStorage.getItem("loginObj"));
  const userData = storedData1;
  const { showFeedback, closeFeedback } = useServicePageFeedback(userData?.code, 'Oral Care');
    const loginToastRef = useRef(null);
  const [attrs, setAttrs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [uploadedImage, setUploadedImage] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const toastRef = useRef(null);
  const [expandedCard, setExpandedCard] = useState(null);
  
//   const [seventhSection, setSeventhSection] = useState([]);
 const [report_count, setReportCount] = useState(null);
  const endpointBase = process.env.REACT_APP_REPORTCOUNTURL;
  const countApiUrl = `${endpointBase}oralcare/reports/count`;
  const { patientData } = usePatientData();


const handleCardClick = (item) => {
  const subheading = item?.subheading?.toLowerCase() || "";

  // VisionCare is live — open its page
  if (subheading === "visioncare") {
    navigate("/visioncare");
    return;
  }

  if (subheading === "caresathi") {
    navigate("/caresathi");
  } else if (subheading === "skincare") {
    navigate("/skincare");
  } else if (subheading === "smartvitals") {
    navigate("/smartvital");
  } else if (subheading === "oralcare") {
    navigate("/oralcare");
  } else if (subheading === "lungscare") {
    navigate("/lungscare");
  } else if (subheading === "smart report") {
    navigate("/smartreport");
  } else if (subheading === "symptomchecker") {
    navigate("/symptomchecker");
  } else if (subheading === "smart diet") {
    navigate("/smartdiet");
  } else {
    console.warn("No route found for:", subheading);
  }
};

  


   const handleOpen = (e) => {
    if (!userData?.code) {
      e.preventDefault();
      // loginToastRef.current?.showLoginToast();
      openLogin();
      return;
    }
    setIsModalOpen(true);


  };
  const handleClose = () => {
    setIsModalOpen(false);
    setUploadedImage(null);
    setPdfUrl(null);
  };
   const handleSecondButton = () => {
  navigate("/aireports", {
    state: {
      tab: "oral_care", // 👈 change based on requirement
    },
  });
};
  

  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  };


  console.log(userData, "iuhklnlk");



  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };


  useEffect(() => {
    let isMounted = true;
    getOralCareData()
      .then(res => {
        if (!isMounted) return;
        // grab the first entry’s attributes
        const entry = res.data?.data?.[0]?.attributes;
        setAttrs(entry || {});
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => { isMounted = false; };
  }, []);
  useEffect(() => {
      if (!countApiUrl) return;
    
      const fetchCount = async () => {
        try {
          const res = await fetch(countApiUrl);
          const data = await res.json();
          setReportCount(data.report_count ?? null);
        } catch (err) {
          console.error("Failed to fetch report count:", err);
        }
      };
    
      fetchCount();
    }, [countApiUrl]);

  if (loading) return <div className="p-8 text-center">Loading…</div>;
  if (error) return <div className="p-8 text-center text-red-600">Error loading data.</div>;
  if (!attrs) return <div className="p-8 text-center">No data</div>;

  // now attrs.firstcomp is an array
 const firstcompItem = attrs.first?.[0] || {};
  const heading = firstcompItem.heading || '';
  const subheading = firstcompItem.subheading || '';
  const description = firstcompItem.description || '';
  const image = firstcompItem.imgurl || '';
  const button = firstcompItem.button || '';
  const button1 = firstcompItem.button1 || '';

  const firstSectionItems = [
    {
      heading,
      subheading,
      description,
      button,
      button1,
      onButtonClick: handleOpen,
      onSecondButtonClick: handleSecondButton,
      image: image,
    },
  ];

  const secondcompArr = attrs.second?.[0]?.secsub || [];
  const thirdSection = attrs.third?.[0] || {};
  const fourthSection = attrs.fourth?.[0] || {};
  const fifthSection = attrs.fifth?.[0] || {};
  const sixthSection = attrs.sixth?.[0] || {};
  const sixthSectionItems = sixthSection?.sixthsub || [];
  const seventhSection = attrs.seventh?.[0] || {};
  const seventhSectionItems = seventhSection?.sevensub || [];

return (
  <>
    <LoginToast ref={loginToastRef} />
    <Toast ref={toastRef} position="top-right" />
    
    <section>
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-[#42BA85]/8 to-transparent rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-32 right-16 w-96 h-96 bg-gradient-to-tr from-[#F3F8FF]/10 to-transparent rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}
        ></div>
        <div
          className="absolute top-1/2 left-1/4 w-48 h-48 bg-gradient-to-br from-[#42BA85]/6 to-transparent rounded-full blur-2xl animate-bounce"
          style={{ animationDelay: '2s', animationDuration: '3s' }}
        ></div>
      </div>

      {/* SECTION 1: HERO / HEADER */}
      <IntroSection items={firstSectionItems} 
       report_count={report_count}/>

      {/* SECTION 2: SECOND SECTION */}
      <section className="bg-[#D9F1E7]">
        <SecondSection items={secondcompArr} />
      </section>

      {/* SECTION 3: THIRD SECTION */}
      {Object.keys(thirdSection).length > 0 && (
        <ThirdSection data={thirdSection} />
      )}

      {/* SECTION 4: FOURTH SECTION */}
      {Object.keys(fourthSection).length > 0 && (
        <CheckHealthSteps data={fourthSection} onButtonClick={handleOpen} />
      )}

      {/* SECTION 5: FIFTH SECTION */}
      {Object.keys(fifthSection).length > 0 && (
        <ConcernsSection data={fifthSection} />
      )}

      {/* SECTION 6: SIXTH SECTION */}
      {Object.keys(sixthSection).length > 0 && (
        <CurebaySolutions
          data={sixthSection}
          onCardClick={handleCardClick}
        />
      )}

      
    </section>

    {/* MODAL: LUNG TEST DIALOG */}
    {isModalOpen && (
        <DentalUpload
        patientId={userData?.code}
        serviceName="Oral Care"
        sourcechannel={patientData?.sourcechannel}   
        createdBy={patientData?.createdBy}
        
        initialVisible={isModalOpen}
          onCloseInitial={handleClose}
      />
      )}
  {showFeedback && (
    <FeedbackModal service="Oral Care" patientId={userData?.code} onClose={closeFeedback} />
  )}
  </>
);
};

export default OralCare;

  